module.exports = __webpack_public_path__ + "static/bgAsset-nz-1ff69b4f01c09749730fe7b8b50160be.jpg";